// 접속 상태·기기 종류

// iPadOS 는 사파리가 PC(맥)처럼 보이고, 삼성 태블릿도 "PC 버전" 브라우저면 리눅스 PC처럼 보이므로 터치·화면 크기까지 확인한다
export const detectDevice = () => {
    const ua = navigator.userAgent || '';
    const touchMac = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
    if (/iPad|Tablet|PlayBook|Silk/i.test(ua) || touchMac || (/Android/i.test(ua) && !/Mobile/i.test(ua))) return 'tablet';
    if (/iPhone|iPod|Android|Mobile|IEMobile|Opera Mini/i.test(ua)) return 'phone';
    const touchOnly = window.matchMedia?.('(pointer: coarse)').matches && !window.matchMedia?.('(any-pointer: fine)').matches;
    if (touchOnly) return Math.min(window.screen.width, window.screen.height) >= 600 ? 'tablet' : 'phone';
    return 'desktop';
};

export const DEVICE_LABEL = { desktop: 'PC', tablet: '태블릿', phone: '휴대폰' };
export const STATUS_LABEL = { online: '온라인', idle: '자리 비움', dnd: '방해 금지', offline: '오프라인' };

// 기기 한 대의 상태 설명: 방해 금지는 지금 보고 있는지까지
export const deviceStatusText = ({ device, status, active }) =>
    `${DEVICE_LABEL[device] || device} ${STATUS_LABEL[status] || status}${status === 'dnd' ? (active ? '(보는 중)' : '(자리 비움)') : ''}`;

export const presenceText = (user) => {
    if (!user || user.isOnline === false) return STATUS_LABEL.offline;
    const devices = user.devices || [];
    if (!devices.length) return STATUS_LABEL[user.status] || STATUS_LABEL.online;
    return devices.map(deviceStatusText).join(' · ');
};
